// UI strings for a show line that is writing seen on screen, not speech (DialogueLine.written:
// Talisa's letter, GoT S3E07; listen/WrittenNote.tsx), and the Kirje step's door to it. The line
// has no recording; the note says so and links where its text is published (the wiki page,
// Peterson's post). Finnish (default) and English side by side; en has the same shape.
// Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const writtenLinesFi = {
  /** What the line is, by DialogueLine.written.what. */
  what: { letter: 'Ruudulla näkyvä kirje, ei äänitettä.' },
  /** Before the source links. */
  text: 'Teksti:',
  /** The wiki page's link. */
  wiki: 'wiki',
  /** Peterson's post: "Peterson, dothraki.com 10.6.2013". */
  peterson: 'Peterson',
  /** The shadow tool instead of "no recording yet": there is none to come (listen/ShadowTool.tsx). */
  noModel: { letter: 'Kirje on ruudulla näkyvää tekstiä, joten siitä ei ole äänitettä.' },
  /** The Kirje step's door to the model letter (weekhub/StepPages.tsx). */
  model: 'Lue mallikirje: Talisan kirje',
};

export const writtenLinesEn: typeof writtenLinesFi = {
  what: { letter: 'A letter seen on screen, no recording.' },
  text: 'Text:',
  wiki: 'wiki',
  peterson: 'Peterson',
  noModel: { letter: 'The letter is text seen on screen, so there is no recording of it.' },
  model: 'Read the model letter: Talisa’s letter',
};

// Messages.writtenLines (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('writtenLines', writtenLinesFi, writtenLinesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof writtenLinesFi> {}
}
